module.exports = __webpack_public_path__ + "static/media/abbas.cc772bfb.jpg";